/* @ngInject */
const pieceFields = (
  pieceLabels,
  types,
  icons
) => {
  const self = {}

  self.name = {
    ref: 'name',
    label: pieceLabels.fields.name.text,
    icon: icons.piece.name,
    type: types.text(),
    required: true,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },

  }

  self.quantity = {
    ref: 'quantity',
    label: pieceLabels.fields.quantity.text,
    icon: icons.piece.quantity,
    type: types.integer,
    required: true,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },

  }
  self.sendingDate = {
    ref: 'sendingDate',
    label: pieceLabels.fields.sendingDate.text,
    icon: icons.piece.sendingDate,
    type: types.date,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.sendingPlace = {
    ref: 'sendingPlace',
    label: pieceLabels.fields.sendingPlace.text,
    icon: icons.piece.sendingPlace,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.weight = {
    ref: 'weight',
    label: pieceLabels.fields.weight.text,
    icon: icons.piece.weight,
    type: types.decimal,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  return self
}
export default pieceFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/resources/fields.resource.js